import React from 'react';

import { Show, TextField, SimpleShowLayout } from 'react-admin';

import { ActionsWithBackButton } from '../../../components/actionbars/ActionsWithBackButton';
import { NotificationSubscriptionEventType } from 'entities/NotificationSubscriptionEventType';
import { ThirdPartyField } from 'components/fields/ThirdPartyField';
import { SelectEnumField } from 'components/fields/SelectEnumField';
import { DateTimeField } from 'components/fields/DateFormatField';


export const ClientNotificationSubscriptionShow = (props) => (
	<Show actions={<ActionsWithBackButton />} {...props}>
		<SimpleShowLayout>
			<TextField source='id' />
			<SelectEnumField source="event_type"
				enumObj={NotificationSubscriptionEventType} enumName="notification_subscription" />
			<ThirdPartyField source='oauth2_client_id' addLabel />
			<DateTimeField source='created_at' withLocalTimeZone addLabel />
			<TextField source='callback_url' />
		</SimpleShowLayout>
	</Show>
);
